import { render, staticRenderFns } from "./producer_edit_producer_data_page.vue?vue&type=template&id=62def454&scoped=true"
import script from "./producer_edit_producer_data_page.vue?vue&type=script&lang=js"
export * from "./producer_edit_producer_data_page.vue?vue&type=script&lang=js"
import style0 from "./producer_edit_producer_data_page.vue?vue&type=style&index=0&id=62def454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62def454",
  null
  
)

export default component.exports